import { render, staticRenderFns } from "./DeleteQuotation.vue?vue&type=template&id=c9cd6efe&"
import script from "./DeleteQuotation.vue?vue&type=script&lang=js&"
export * from "./DeleteQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports